<template>
  <el-container class="list_main_content">
    <el-aside width="200px" v-if="!$route.meta.single" v-show="asideShow">
      <p class="flow_tree_top_title">我转办的分类</p>
      <FlowTree
        ref="FlowTree"
        @currentTree="getCurrent"
        :loadCount="loadCount"
      ></FlowTree>
    </el-aside>
    <div
      class="navbar-collapse"
      :class="{ 'navbar-collapse-right': !asideShow }"
      :style="navbarCollapseStyle"
      @click="asideShow = !asideShow"
    >
      <div class="navbar-collapse-bg" style="display: none;">
        <i
          class="navbar-collapse-arrow"
          :class="{
            'el-icon-arrow-left': asideShow,
            'el-icon-arrow-right': !asideShow,
          }"
        ></i>
      </div>
    </div>
    <el-container  :style="conheight">
      <collapse-search>
      <div class="content_top_wrap">
        <searchForm
            ref="searchForm"
            :options="searchOptions"
            :divide="3"
            @search="search('find')"
          />
        <el-row style="padding:8px 0px 8px 0px;">
          <el-col :span="24">
            <el-button size="small" type="primary" @click="search('find')">查询</el-button>
            <el-button size="small" @click="reset">重置</el-button>
          </el-col>
        </el-row>
        <!-- <el-input
          size="small"
          style="width:240px;"
          clearable
          placeholder="流程事项/任务名称/工单号"
          prefix-icon="el-icon-search"
          v-model="tableData"
          @keyup.enter.native="searchEnterFun"
        ></el-input>
        <div class="date_wrap">
          <a class="search_form_label">到达时间</a>
          <el-date-picker
            v-model="date"
            type="datetimerange"
            align="left"
            size="small"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </div>
        <el-row>
          <el-col :span="24">
            <el-button
              style="margin-left: 16px"
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search('find')"
              >查询</el-button
            >
            <el-button size="small" @click="reset" icon="el-icon-refresh" style="margin-left: 16px"
              >重置</el-button
            >
          </el-col>
        </el-row> -->

      </div>
      </collapse-search>
      <el-main class="delegate_content">
        <!-- default-sort  排序 -->
        <el-table
          :data="rows"
          style="width: 100%;"
          header-cell-class-name="todo-header-row"
          row-class-name="todo-row"
          size="medium"
          height="100%"
          v-loading.fullscreen.lock="fullscreenLoading"
          :default-sort="{ prop: 'createTime', order: 'descending' }"
        >
          <!-- <el-table-column type="index" width="50" align="center" label="序号"></el-table-column> -->
          <el-table-column
            prop="workOrderNo"
            width="120"
            align="left"
            label="工单号"
            sortable
          ></el-table-column>
          <el-table-column label="流程事项">
            <template slot-scope="scope">
              <span class="todo-subject" @click="handleRowClick(scope.row)">{{
                scope.row.taskSubject
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="任务名称"
            align="left"
            width="120"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.taskName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            sortable
            label="到达时间"
            align="left"
            width="160"
          ></el-table-column>
          <!-- <el-table-column
            prop="finishTime"
            label="任务完成时间"
            sortable
            align="left"
            width="160"
          ></el-table-column> -->
          <el-table-column
            prop="assigneeName"
            label="被转办人"
            align="left"
            width="100"
          ></el-table-column>
          <!-- <el-table-column width="60" align="left" label="类型">
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.turnType == 'turn'"
                type="success"
                size="small"
                >转办</el-tag
              >
            </template>
          </el-table-column> -->
          <el-table-column width="80" align="center" label="操作">
            <template slot-scope="scope">
              <a class="shouhui" v-if="!scope.row.finishTime"  @click="delBpmTaskMyDelegateById(scope.row)">收回</a>
              <!-- <el-button v-if="!scope.row.finishTime" type="danger" @click="delBpmTaskMyDelegateById(scope.row)" size="small" >收回</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="45px;line-height: 45px;">
        <el-row type="flex" justify="end" style="float: right;">
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import FlowTree from "@/components/flow/flowTree.vue";
import utils from "@/utils.js";
import process from "@/api/process";
import searchForm from "@/components/common/searchForm.vue";
export default {
  name: "myDelegate",
  components: {
    FlowTree,
    searchForm
  },
  props: {
    defKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      asideShow: false,
      tableData: "",
      date: "",
      currentTree: "",
      fullscreenLoading: true,
      conheight:{ height:'' },
      searchOptions: [
        {
          property: "a.task_subject_",
          operation: "LIKE",
          type: "text",
          label: "流程标题",
          placeholder: "请输入流程标题"
        },
        {
          property: "work_order_no",
          operation: "LIKE",
          type: "text",
          label: "工单号",
          placeholder: "请输入工单号"
        },
      ],
    };
  },
  computed: mapState({
    navbarCollapseStyle: function() {
      if (this.asideShow) {
        return { left: "200px" };
      }
      return { left: "0px" };
    },
    rows: (state) => state.storeProcess.rows,
    pagination: (state) => state.storeProcess.pagination,
    total: (state) => state.storeProcess.total,
  }),
  methods: {
    //页面高度计算
     getHeight(){
      this.conheight.height = window.innerHeight - 112 + "px";
    },
    //根据任务ID收回转办任务
    delBpmTaskMyDelegateById(row) {
      this.$confirm("确认收回此任务?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.$store
          .dispatch("storeProcess/retrieveBpmTask", row.taskId)
          .then(() => {
            this.search();
          });
      });
    },
    //Loading 加载中
    openFullScreen() {
      this.fullscreenLoading = true;
    },
    handleSizeChange: function(size) {
      //每页下拉显示数据
      this.$store.dispatch("storeProcess/setPaginationSize", size);
      this.search();
    },
    handleCurrentChange: function(currentPage) {
      //点击第几页
      this.$store.dispatch("storeProcess/setPaginationPageNum", currentPage);
      this.search();
    },
    //回车查询
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.search("find");
      }
    },
    // 查询
    search(str) {
      if (str == "find") {
        this.$store.dispatch("storeProcess/setPaginationPageNum", 1);
      }
      let querys = [];
      if (this.$refs.searchForm) {
        querys = this.$refs.searchForm.getQuerys();
      }
      let queryFilter = {};

      queryFilter = { pageBean: this.pagination, querys, sorter: this.sorter };
      this.openFullScreen();
      this.$store
        .dispatch("storeProcess/getDelegate", queryFilter)
        .then(() => {
          this.fullscreenLoading = false;
        });
    },
    //重置
    reset() {
      this.$refs.searchForm.reset();
      this.search("find");
    },
    handleRowClick(row) {
      //this.$router.push("/instRead/" + row.procInstId+"/delegate");
      let token = this.$store.state.login.currentUser.token;
      let url = window.context.front;
      url += "/instRead/" + row.procInstId + "/delegate";
      url += "?token=" + token;
      window.open(
        url,
        "_blank",
        "width=" +
          (window.screen.availWidth - 10) +
          ",height=" +
          (window.screen.availHeight - 70)
      );
    },
    //子组件传值父组件(待办分类查询)
    getCurrent(data) {
      if (data.id == 6) {
        this.openFullScreen();
        let pageBean = { pageBean: this.pagination };
        this.$store.dispatch("storeProcess/getDelegate", pageBean).then(() => {
          this.fullscreenLoading = false;
        });
      } else {
        let ids = [];
        this.getFlowTrees(data, ids);
        this.currentTree = ids.join(",");
        this.search("find");
      }
    },
    getFlowTrees(data, ids) {
      ids.push(data.id);
      let arr = data.children;
      for (var i = 0; i < arr.length; i++) {
        this.getFlowTrees(arr[i], ids);
      }
    },
    loadCount() {
      return process.getDelegateCount({});
    },
  },
  created() {
 //页面高度设置
    window.addEventListener('resize', this.getHeight);
    this.getHeight();

    let querys = [];
    if (this.defKey) {
      querys.push({
        property: "hi.proc_def_key_",
        value: this.defKey,
        operation: "EQUAL",
        relation: "AND",
      });
    }
    let pageBean = {
      pageBean: { page: "1", pageSize: "20", showTotal: "true" },
      querys,
    }; //初次加载默认pageBean
    this.$store.dispatch("storeProcess/getDelegate", pageBean).then(() => {
      //页面加载调用tudo.js里面的分页方法
      this.fullscreenLoading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .search_form_label{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #52535E;
}

/deep/ .shouhui{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #1890FF !important;
}


.list_main_content {
  padding: 0;
}

/deep/ .el-footer{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  padding: 16px 0px !important;
  span,.el-pagination__total,.el-pagination__jump{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager li,.el-input__inner{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager .active{
    color: #1890FF !important;
  }
} 

/deep/.el-table th{
  height: 48px;
  background: #F0F2F5;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
}

// /deep/.el-table tr:nth-child(even){
//     background: rgb(240, 241, 241);
// }

/deep/.el-table th,
/deep/.el-table td {
  //border-right:1px dashed #000000;
  border-bottom: 1px solid #F0F2F5;
  border-right: 0px dashed rgb(218, 218, 218);
}

/deep/.el-table tr:hover > td{
   background-color:#EDF6FB !important;
    .todo-subject{
      color: #1890FF !important;
    }
    .todo-subject-read{
      color: #1890FF !important;
    } 
}

/deep/.el-table--medium th,
/deep/ .el-table--medium td {
  padding: 1px 0;
}

/deep/.el-table .cell {
  padding-left: 16px;
  padding-right: 0px;
  // line-height: unset;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
}
/deep/.todo-subject,/deep/.el-tooltip>span{
  font-size: 12px !important;
}
.el-table /deep/ tr.todo-row {
  font-size: 12px;
  color: $--color-text-regular;
  height: 48px;
}


.el-container {
  background-color: #fff;
  padding: 0px !important;
}



/deep/.el-pagination {
  text-align: justify;
  margin: 0 auto;
  font-family: "微软雅黑", "宋体", Arial, sans-serif !important;
  font-size: 12px !important;
}
/deep/.pagination {
  margin-left: 0px;
  margin-top: 16px;
  text-align: left;
  font-family: "微软雅黑", "宋体", Arial, sans-serif;
  font-size: 12px !important;
}

.el-header {
  border-bottom: 1.5px solid #ededed;
}

/deep/.el-button {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}
.todo-subject {
  cursor: pointer;
}

.todo-subject {
  color: $--theme-color;
}
.top-title {
  line-height: 58px;
  margin-left: 20px;
  font-size: 16px;
  color: #a2a2a2;
}
/deep/.el-tree {
  position: relative;
  cursor: default;
  background: #fff;
  color: $--color-text-primary;
  font-size: 13px;
}
.delegate_content{
  padding:0px;
}
.content_top_wrap {
  display: flex;
  flex-direction: row;
  margin:0px 0 8px 0px;
  flex-wrap: wrap;
  &_form {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    /deep/ .el-input__prefix,
    /deep/.el-input__suffix {
      height: 32px;
    }
    .form_input {
      margin-right: 10px;
    }
    .form_date_picker,
    .form_org_selector {
      margin-right: 10px;
      min-width: 300px;
    }
  }
}
</style>
